<template>
    <div
        :style="backUrl ? { backgroundImage: `url(${backUrl})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' } : {}"
        class="left-one-right-two-container"
    >

        <!-- 底部余量占位：固定高度，不拉伸内容 -->
        <div class="top-margin"></div>
        <!-- 顶部标题展示 -->
        <div v-if="title" class="component-title">
            {{ title }}
        </div>

        <!-- 左右布局容器：核心内容区，不拉伸 -->
        <div style="margin-top: 100px" class="layout-wrapper">
            <div class="layout-container">
                <!-- 左侧内容 -->
                <div class="left-column">
                    <div class="column-content" v-html="leftContent"></div>
                </div>

                <!-- 右侧两列容器 -->
                <div class="right-columns">
                    <div class="right-column top">
                        <div class="column-content" v-html="rightContents[0]"></div>
                    </div>
                    <div class="right-column bottom">
                        <div class="column-content" v-html="rightContents[1]"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部余量占位：固定高度，不拉伸内容 -->
        <div class="bottom-margin"></div>
    </div>
</template>

<script>
export default {
    name: "LeftOneRightTwo",
    props: {
        sourceData: {
            type: String,
            required: true,
            default: ""
        },
        title: {
            type: String,
            default: "",
        },
        backUrl: {
            type: String,
            default: ""
        },
        detailUrl:{
            type: String,
            default: ''
        },
    },
    data() {
        return {
            leftContent: "",
            rightContents: [],
        };
    },
    watch: {
        sourceData: {
            immediate: true,
            handler(newSource) {
                this.parseSourceData(newSource);
            },
        },
    },
    methods: {
        parseSourceData(source) {
            try {
                const parts = source.split("@FUWENBEN@");
                this.leftContent = parts[0] || "<p>无左侧内容</p>";
                this.rightContents = [
                    parts[1] || "<p>无右侧上内容</p>",
                    parts[2] || "<p>无右侧下内容</p>",
                ];
            } catch (error) {
                console.error("左一右二布局解析失败:", error);
                this.leftContent = "<p>解析错误</p>";
                this.rightContents = ["<p>解析错误</p>", "<p>解析错误</p>"];
            }
        },
    },
};
</script>

<style scoped>
/* 根容器：仅控制基础样式，不拉伸 */
.left-one-right-two-container {
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px;
    background-color: #fff; /* 兜底背景色 */
}

/* 顶部标题 */
.component-title {
    padding: 16px 20px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
}

/* 内容区包装器：限制内容高度，避免拉伸 */
.layout-wrapper {
    max-width: 1200px;
    margin: 0 auto;
    /* 核心：固定内容区最大高度，确保容器完整显示 */
    max-height: 500px;
}

/* 布局容器：严格控制间隔，不拉伸 */
.layout-container {
    display: flex;
    gap: 10px; /* 左列与右列的水平间隔（10px生效） */
    height: 100%;
}

/* 左侧列：独立白色容器，不拉伸 */
.left-column {
    flex: 1;
    padding: 20px;
    box-sizing: border-box;
    background-color: white;
    /* 避免内容过少时容器过矮，内容过多时滚动 */
    min-height: 300px;
    max-height: 450px;
    overflow-y: auto;
}

/* 右侧两列容器：控制内部垂直间隔 */
.right-columns {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px; /* 右列上下间隔（10px生效） */
    height: 100%;
}

/* 右侧上下列：独立白色容器，高度均分 */
.right-column {
    flex: 1; /* 上下列高度自动均分，不拉伸 */
    padding: 20px;
    box-sizing: border-box;
    background-color: white;
    /* 内容过多时滚动，避免容器撑高 */
    min-height: 145px;
    max-height: 220px;
    overflow-y: auto;
}

/* 内容样式：正常换行，不拉伸容器 */
.column-content {
    line-height: 1.8;
    color: #333;
}

.column-content p {
    margin: 0 0 12px 0;
}

.column-content p:last-child {
    margin-bottom: 0;
}

.column-content img {
    max-width: 100%;
    height: auto;
    margin: 10px 0;
}

/* 底部余量：固定高度占位，不影响内容区 */
.bottom-margin {
    height: 15vh; /* 底部余量占视口高度的25%（可调整，如30vh） */
    clear: both;
}
.top-margin {
    height: 5vh; /* 底部余量占视口高度的25%（可调整，如30vh） */
    clear: both;
}
/* 响应式适配：小屏垂直排列，间隔保留 */
@media (max-width: 768px) {
    .layout-container {
        flex-direction: column;
        gap: 10px; /* 垂直布局时，左列与右列上的间隔 */
    }

    .left-column, .right-columns {
        max-height: none;
        min-height: auto;
    }

    .right-column {
        max-height: none;
    }

    .bottom-margin {
        height: 15vh; /* 小屏底部余量减少 */
    }
    .top-margin {
        height: 5vh; /* 小屏底部余量减少 */
    }
}
</style>